export const MIXPANEL_TOKENS: Record<string, string | undefined> = {
  client: process.env.REACT_APP_CLIENT_MIXPANEL_TOKEN,
  provider: process.env.REACT_APP_WEBSITE_MIXPANEL_TOKEN,
  signup: process.env.REACT_APP_WEBSITE_MIXPANEL_TOKEN,
};

export const ACTIVE_MIXPANEL_TOKEN =
  MIXPANEL_TOKENS[process.env.REACT_APP_FAY_APP ?? ""];
